export default function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-trigger/~/rc-util/es/Dom/contains.js
// module id = 1127
// module chunks = 0 1